export { default } from './SkeletonBreakingDealsMobile';
